import React from 'react';
import PublicLayout from '../../components/layout/PublicLayout';

const PrivacyPolicyScreen = () => {
  return (
    <PublicLayout title="Privacy Policy">
          <p className="effective-date">Effective Date: July 24, 2025</p>

          <p>
            Welcome to <strong>MeetUrExpert</strong> (for users) and <strong>MeetUrExpert for Professional</strong> (for professionals). We are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our platforms, including our website, mobile applications, and related services.
          </p>

          <h2>1. Information We Collect</h2>
          <ul>
            <li><strong>Personal Information:</strong> Name, email address, mobile number, gender, date of birth, address, and other information you provide during registration or profile updates.</li>
            <li><strong>Professional Information (for professionals):</strong> Qualifications, certifications, experience, and other details provided to verify your professional status.</li>
            <li><strong>Health Information (for users):</strong> Details about your health, medical history, appointments, and any files (such as audio or documents) you upload for consultations.</li>
            <li><strong>Usage Data:</strong> Information about how you use our services, including appointment history, search queries, and interactions with other users or professionals.</li>
            <li><strong>Technical Data:</strong> IP address, browser type, device information, and cookies.</li>
          </ul>

          <h2>2. How We Use Your Information</h2>
          <ul>
            <li>To provide and manage our healthcare and professional services, including scheduling appointments and facilitating communication between users and professionals.</li>
            <li>To verify professional credentials and maintain the quality of our network.</li>
            <li>To personalize your experience and improve our platforms.</li>
            <li>To process payments and manage billing.</li>
            <li>To send notifications, reminders, and important updates.</li>
            <li>To ensure security, prevent fraud, and comply with legal obligations.</li>
          </ul>

          <h2>3. How We Share Your Information</h2>
          <ul>
            <li>With professionals (on Meet Your Expert) for the purpose of providing services to users.</li>
            <li>With users (on Expert for Professional) for the purpose of facilitating appointments and communication.</li>
            <li>With service providers who assist us in operating our platforms (e.g., payment processors, cloud storage, notification services).</li>
            <li>With law enforcement or regulatory authorities if required by law.</li>
            <li>We do <strong>not</strong> sell your personal information to third parties.</li>
          </ul>

          <h2>4. Data Security</h2>
          <p>
            We implement industry-standard security measures to protect your data. However, no method of transmission over the Internet or electronic storage is 100% secure. We strive to use commercially acceptable means to protect your personal information but cannot guarantee its absolute security.
          </p>

          <h2>5. Your Rights and Choices</h2>
          <ul>
            <li>You can access, update, or delete your personal information by contacting us or using your account settings.</li>
            <li>You may opt out of receiving non-essential communications at any time.</li>
            <li>You may request a copy of your data or ask us to delete your account.</li>
          </ul>

          <h2>6. Children's Privacy</h2>
          <p>
            Our services are not intended for children under the age of 18. We do not knowingly collect personal information from children. If you believe a child has provided us with personal information, please contact us to have it removed.
          </p>

          <h2>7. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any significant changes by posting the new policy on this page and updating the effective date.
          </p>

          <h2>8. Contact Us</h2>
          <p>
            If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at:<br />
            <a href="mailto:meeturexpert@gmail.com">meeturexpert@gmail.com</a>
          </p>
    </PublicLayout>
  );
};

export default PrivacyPolicyScreen;